import { render, staticRenderFns } from "./Ssxq.vue?vue&type=template&id=19751443&scoped=true"
import script from "./Ssxq.vue?vue&type=script&lang=js"
export * from "./Ssxq.vue?vue&type=script&lang=js"
import style0 from "./Ssxq.vue?vue&type=style&index=0&id=19751443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19751443",
  null
  
)

export default component.exports